module.exports = __webpack_public_path__ + "img/section_round_3.4e820062.svg";